// extracted by mini-css-extract-plugin
export var cardIcon = "_6s-5";
export var cardIconUnframed = "_6s-9";
export var checkboxCard = "_6s-0";
export var checkboxCardSelected = "_6s-4";
export var disabled = "_6s-2";
export var interactive = "_6s-1";
export var outerBorder = "_6s-3";
export var spacerMedium = "_6s-8";
export var spacerSmall = "_6s-7";
export var spacerXsmall = "_6s-6";